.page {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2.5rem;
  padding: max(2rem, env(safe-area-inset-top)) 1rem max(2rem, env(safe-area-inset-bottom));
}

.hero {
  text-align: center;
  max-width: 26rem;
}

.title {
  margin: 0;
  font-size: clamp(2.5rem, 11vw, 3.75rem);
  font-weight: 900;
  letter-spacing: -0.04em;
  line-height: 0.95;
  text-transform: uppercase;
}

.tagline {
  margin: 1rem 0 0;
  color: var(--color-muted);
  font-size: 1.0625rem;
  line-height: 1.5;
}

.chat {
  width: 100%;
  max-width: 24rem;
  border: 1px solid var(--color-border);
  border-radius: 1.5rem;
  background: var(--color-surface);
  backdrop-filter: blur(12px);
  overflow: hidden;
}

.chatHeader {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem 1rem;
  border-bottom: 1px solid var(--color-border);
}

.avatar {
  display: grid;
  place-items: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background: var(--color-accent);
  color: var(--color-bg);
  font-size: 0.8125rem;
  font-weight: 800;
}

.narrator {
  margin: 0;
  font-weight: 700;
}

.status {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  margin: 0.125rem 0 0;
  color: var(--color-muted);
  font-size: 0.8125rem;
}

.statusDot {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: var(--color-accent);
  animation: blink 1.4s ease-in-out infinite;
}

.messages {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  margin: 0;
  padding: 1rem;
  list-style: none;
}

.bubble {
  max-width: 85%;
  padding: 0.625rem 0.875rem;
  border-radius: 1.125rem 1.125rem 1.125rem 0.375rem;
  background: var(--color-bubble);
  line-height: 1.4;
  opacity: 0;
  animation: arrive 0.4s ease-out forwards;
}

.typing {
  display: flex;
  gap: 0.25rem;
  padding: 0.75rem 0.875rem;
  border-radius: 1.125rem 1.125rem 1.125rem 0.375rem;
  background: var(--color-bubble);
}

.typing span {
  width: 0.4375rem;
  height: 0.4375rem;
  border-radius: 50%;
  background: var(--color-muted);
  animation: bounce 1.2s ease-in-out infinite;
}

.typing span:nth-child(2) {
  animation-delay: 0.15s;
}

.typing span:nth-child(3) {
  animation-delay: 0.3s;
}

.build {
  color: var(--color-muted);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.75rem;
}

@keyframes arrive {
  from {
    opacity: 0;
    transform: translateY(0.5rem);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@keyframes bounce {
  0%,
  60%,
  100% {
    transform: none;
  }
  30% {
    transform: translateY(-0.25rem);
  }
}

@keyframes blink {
  50% {
    opacity: 0.3;
  }
}

@media (prefers-reduced-motion: reduce) {
  .bubble {
    opacity: 1;
    animation: none;
  }

  .statusDot,
  .typing span {
    animation: none;
  }
}
